import { render } from "./FishStarters.vue?vue&type=template&id=ca06e5ec"
import script from "./FishStarters.vue?vue&type=script&lang=js"
export * from "./FishStarters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__